import React, { useMemo } from "react";
import { Grid } from "@mui/material";
import DecoAutocomplete from "./DecoAutocomplete";
import {
  griptypeOptions,
  gripsizeOptions,
  gripcolorOptions,
} from "../constants/closetOptions";

const GripOptions = ({
  gripStyle,
  selectedSeries,
  setSelectedSeries,
  selectedSize,
  setSelectedSize,
  selectedColor,
  setSelectedColor,
  columns = 2,
}) => {
  const availableSeries = useMemo(
    () => griptypeOptions[gripStyle] || [],
    [gripStyle]
  );
  const availableSizes = useMemo(
    () => gripsizeOptions[selectedSeries] || [],
    [selectedSeries]
  );
  const availableColors = useMemo(
    () => gripcolorOptions[selectedSeries] || [],
    [selectedSeries]
  );

  if (!gripStyle) return null;

  return (
    <>
      <Grid item xs={6}>
        <DecoAutocomplete
          labelId="grip-series-label"
          value={availableSeries.includes(selectedSeries) ? selectedSeries : ""}
          onChange={(e) => setSelectedSeries(e.target.value)}
          menuItems={availableSeries}
          label="Grip Series"
        />
      </Grid>

      {availableSizes.length > 0 && (
        <Grid item xs={6}>
          <DecoAutocomplete
            labelId="grip-size-label"
            value={availableSizes.includes(selectedSize) ? selectedSize : ""}
            onChange={(e) => setSelectedSize(e.target.value)}
            menuItems={availableSizes}
            label="Grip Size"
          />
        </Grid>
      )}

      {availableColors.length > 0 && (
        <Grid item xs={6}>
          <DecoAutocomplete
            labelId="grip-color-label"
            value={availableColors.includes(selectedColor) ? selectedColor : ""}
            onChange={(e) => setSelectedColor(e.target.value)}
            menuItems={availableColors}
            label="Grip Colour"
          />
        </Grid>
      )}
    </>
  );
};

export default GripOptions;
